module.exports = __webpack_public_path__ + "static/media/breakout-arena.22a1a685.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/breakout-arena.jpg
 ** module id = 425
 ** module chunks = 0
 **/